import React, { useContext, useEffect, useState, useRef } from 'react';
import SplashScreen from '../components/SplashScreen';
import { useNavigate, useParams } from "react-router-dom";
import { Alert, Button, Col, Form, Modal, Row } from "react-bootstrap";
import { BiHide, BiShow } from "react-icons/bi";
import { FiAlertTriangle } from "react-icons/fi";
import { axiosNoAuth_IDENT_MGMT_API } from '../utils/AxoisUtilComponent';
import { UserContext } from "../UserContext";
import { useTranslation } from 'react-i18next';
import { LoadingSpinnerForModal } from '../utils/uiUtils';
import { translateAPIError } from '../utils/apiUtils';
import configInfo from '../config/config.json';
//import envConfig from "../config/EnvConfig.json"


const Login = (props) => {

  const { lng } = useParams();

  const { setUser } = useContext(UserContext);

  const { i18n, t } = useTranslation(["common"]);

  const navigate = useNavigate();



  const [showLoginDialog, setShowLoginDialog] = useState(true);

  const [hidePwd, setHidePwd] = useState(true);
  const inputRef = useRef(null);

  const [uiMode, setUIMode] = useState('MODE_LOGIN');
  const [loading, setLoading] = useState(false);
  const [resendCode, setResendCode] = useState(false);
  const [userData, setUserData] = useState(null);

  //let userData = null;

  // Initialize state
  useEffect(() => {
    i18n.changeLanguage(lng);
    setUIMode('MODE_LOGIN');
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);


  const handleLogin = (userData) => {
    if (userData.internalStatus === 'SUCCESS') {
      sessionStorage.setItem("accessToken", userData.accessToken);

      // Clear state
      sessionStorage.removeItem("ActionAdmin.pageState");
      sessionStorage.removeItem("AlarmCategoryAdmin.pageState");
      sessionStorage.removeItem("AlarmRuleAdmin.pageState");
      sessionStorage.removeItem("AppAdmin.pageState");
      sessionStorage.removeItem("AssetAdmin.pageState");
      sessionStorage.removeItem("AssetCollAdmin.pageState");
      sessionStorage.removeItem("AssetImportAdmin.pageState");
      sessionStorage.removeItem("AssetTypeAdmin.pageState");
      sessionStorage.removeItem("BizConfigAdmin.pageState");
      sessionStorage.removeItem("CarparkSpaceAdmin.pageState");
      sessionStorage.removeItem("CCTVCamAdmin.pageState");
      sessionStorage.removeItem("DataInspectAdmin.pageState");
      sessionStorage.removeItem("DatakeyAdmin.pageState");
      sessionStorage.removeItem("DatakeyAudit.pageState");
      sessionStorage.removeItem("DatapointAdmin.pageState");
      sessionStorage.removeItem("DatapointTypeAdmin.pageState");
      sessionStorage.removeItem("DeptAdmin.pageState");
      sessionStorage.removeItem("DeviceAdmin.pageState");
      sessionStorage.removeItem("DocAdmin.pageState");
      sessionStorage.removeItem("FloorAdmin.pageState");
      sessionStorage.removeItem("JobAdmin.pageState");
      sessionStorage.removeItem("LocationAdmin.pageState");
      sessionStorage.removeItem("ModelAdmin.pageState");
      sessionStorage.removeItem("ModelObjAdmin.pageState");
      sessionStorage.removeItem("NotifAdmin.pageState");
      sessionStorage.removeItem("NotifTypeAdmin.pageState");
      sessionStorage.removeItem("PermissionAdmin.pageState");
      sessionStorage.removeItem("RoleAdmin.pageState");
      sessionStorage.removeItem("SaasTenantAdmin.pageState");
      sessionStorage.removeItem("ServiceAdmin.pageState");
      sessionStorage.removeItem("SoundAdmin.pageState");
      sessionStorage.removeItem("PermissionAdmin.pageState");
      sessionStorage.removeItem("UiAppAdmin.pageState");
      sessionStorage.removeItem("UiCompAdmin.pageState");
      sessionStorage.removeItem("UiCompTypeAdmin.pageState");
      sessionStorage.removeItem("UserAdmin.pageState");
      sessionStorage.removeItem("UserGroupAdmin.pageState");

      // Set the user context
      setUser({
        isAuth: true,
        userInfo: userData.userInfo
      });

      i18n.changeLanguage(userData.userInfo.language);

      navigate("/AdminHome/Dashboard", {
        state: {
          target: 'Console'
        }
      });

    } else if (userData.internalStatus === 'MFA_VERIFY') {
      setUIMode('MODE_MFA_VERIFY');
    } else if (userData.internalStatus === 'SET_PWD_SEC') {
      navigate("/NewPwdSecQnA/" + username, {
        state: {
          //mode: userData.internalStatus // ##### NOT USED, CAN REMOVE IF DOES NOT CAUSE ISSUE
        }
      });
    } else if (userData.internalStatus === 'SET_PWD') {
      navigate("/NewPwd/" + username, {
        state: {
          secQuestion: userData.secQuestion
        }
      });
    }
  }

  const handleError = (error) => {

    setErrorMessage(t("I18N_" + error.errorCode));
  }

  const handleDismissChangePwdPromptAlert = () => {
    setShowChangePwdPromptAlert(false);
    handleLogin(userData);
  }

  const [newLogin, setNewLogin] = useState({
    username: "", password: "", veriCode: ""
  });
  var { username, password, veriCode } = newLogin;

  const [forgotPwd, setForgotPwd] = useState({
    username2: "", email: ""
  });
  var { username2, email } = forgotPwd;

  const [errorMessage, setErrorMessage] = useState('');
  const [forgotPwdErrorMessage, setForgotPwdErrorMessage] = useState('');

  const onLoginInputChange = (e) => {
    setNewLogin({ ...newLogin, [e.target.name]: e.target.value })
  }

  const onForgotPwdInputChange = (e) => {
    setForgotPwd({ ...forgotPwd, [e.target.name]: e.target.value })
  }

  const handleLoginSubmit = (e) => {
    e.preventDefault();
    if (!username) {
      setErrorMessage(t("I18N_ERR_Need_Username"));
      return;
    } else if (!password) {
      setErrorMessage(t("I18N_ERR_Need_Password"));
      return;
    }

    const reqBody = {
      "username":     username,
      "password":     password,
      "accountTypes": "SYS_ADMIN,USER", // This is tp prevent other type of non-human user to login, such as tvwall or API.
      "origin":       "IGC_ADMIN_PORTAL",
      "veriCode":     veriCode.trim(),
    }

    return new Promise(async (resolve, reject) => {
      setLoading(true);

      try {
        const res = await axiosNoAuth_IDENT_MGMT_API.post("login", reqBody);

        resolve(res.data);

        // Successful login
        if (res.status === 200) {
          setLoading(false);
          setResendCode(false);

          setUserData(res.data);

          // ##### TEMP HACK - SHOULD NOT HARD CODE PERMISSION HERE #####
          if (   (res.data.internalStatus !== 'SET_PWD')
              && (res.data.internalStatus !== 'SET_PWD_SEC')
              && (res.data.internalStatus !== 'MFA_VERIFY')) {
            if (username !== 'SYSTEM') {
              if (   !res.data.userInfo
                  || !res.data.userInfo.permissions
/*
                  || (   (!res.data.userInfo.permissions.includes('UserAdminFullAccess'))
                      && (!res.data.userInfo.permissions.includes('BuildingAdminFullAccess')))) {
*/
                  || (   (!res.data.userInfo.permissions.includes('UserAdminWriteAccess'))
                      && (!res.data.userInfo.permissions.includes('OrgAdminGeneralWriteAccess'))
                      && (!res.data.userInfo.permissions.includes('BuildingAdminGeneralWriteAccess'))
                      && (!res.data.userInfo.permissions.includes('NotifTypeAdminWriteAccess'))
                      && (!res.data.userInfo.permissions.includes('NotifAdminDeleteAccess')))) {
                setLoading(false);
                setErrorMessage(t("I18N_ERR_Unauthorized_to_use_app"));
                return;
              }
            }
          }

          // Pass control to parent. ### Enhancement: pass back user details, such as first name, etc. ###
          if (   res.data.userInfo                     // Certain cases such as new user, or reset pwd, userInfo is NULL
              && res.data.userInfo.promptChangePwd) {
            setShowChangePwdPromptAlert(true);
          } else {
            handleLogin(res.data);
          }
        }

        setErrorMessage('');
      } catch (error) {
        setLoading(false);

        if (!error.response) {
          setErrorMessage(t("I18N_ERR_General_System_Err"));
          return;
        } else {
          if (error.response.status === 401) {
            if (error.response.data.msg === 'ERR_Must_reset_pwd') {
              // Force user to reset password
              handleError({
                errorCode: error.response.data.msg,
                username: username
              });
            } else if (error.response.data.msg === 'ERR_Veri_Code_Expd') {

              handleError({
                errorCode: error.response.data.msg,
                username: username
              });

              // Allow user to request to resend code
              setResendCode(true);
              setNewLogin({ ...newLogin, 'veriCode': '' });
            } else {
              setErrorMessage(t(translateAPIError(error)));
            }
          } else {
            setErrorMessage(t(translateAPIError(error)));
          }
        }
      }
    });
  }

  const handleLoginCancel = () => {
    setShowLoginDialog(false);
  }

  const onSetForgotPwdMode = () => {
    setUIMode('MODE_FORGOT_PWD');
  }

  const handleForgotPwdSubmit = (e) => {
    e.preventDefault();

    if (!username2) {
      setForgotPwdErrorMessage(t("I18N_ERR_Need_Username"));
      return;
    } else if (!email) {
      setForgotPwdErrorMessage(t("I18N_ERR_Need_Email"));
      return;
    }

    const reqBody = {
      "username": username2,
      "email": email,
      "origApp": 'ADMIN_PORTAL',
      "language": i18n.language
    }

    return new Promise(async (resolve, reject) => {
      setLoading(true);
      try {
        const res = await axiosNoAuth_IDENT_MGMT_API.put("forgot-pwd", reqBody);

        resolve(res.data);

        // Successful login
        if (res.status === 200) {
          setForgotPwdErrorMessage('');

          setUIMode('MODE_FORGOT_PWD_MSG');
          setLoading(false);
        }
      } catch (error) {
        setForgotPwdErrorMessage(t(translateAPIError(error)));
        setLoading(false);
      }
    });
  }

  const handleForgotPwdCancel = () => {
    setUIMode('MODE_LOGIN');
  }

  const handleForgotPwdClose = () => setShowLoginDialog(false);

    const [showChangePwdPromptAlert, setShowChangePwdPromptAlert] = useState(false);

  function ChangePwdPromptAlert() {

    return (
      <>
        <Alert show={showChangePwdPromptAlert} variant="warning" style={{marginBottom:'0'}}>
          <Alert.Heading>{t("I18N_Reminder")}</Alert.Heading>
          <p style={{fontSize:'12px'}}>
            {t("I18N_Change_pwd_reminder_1") + userData.userInfo.pwdAgeLimit + t("I18N_Change_pwd_reminder_2")}
          </p>
          <hr />
          <div className="d-flex justify-content-end">
            <Button onClick={handleDismissChangePwdPromptAlert} variant="outline-secondary" size="sm" type="close" className="mb-3" style={{ marginBottom:'0px', float: 'right', fontWeight: '300' }}>
              {t("I18N_OK")}
            </Button>
          </div>
        </Alert>
      </>
    );
  }

  const handleTogglePwd = (e) => {
    e.preventDefault();
    setHidePwd(!hidePwd);

    // Use setTimeout to allow React to re-render the input with the new type
    // before trying to focus it, which ensures the cursor position is maintained.
    setTimeout(() => {
      if (inputRef.current) {
        inputRef.current.focus();
        // Optional: place the cursor at the end of the input value
        inputRef.current.setSelectionRange(inputRef.current.value.length, inputRef.current.value.length);
      }
    }, 0);
  }


  return (
    <React.Fragment>

      <div>
        <SplashScreen />
      </div>
      {!showChangePwdPromptAlert ?
        <Modal show={showLoginDialog} onHide={handleLoginCancel} centered backdrop="static" >

          <Modal.Header closeButton>
            <Modal.Title style={{ fontSize: '20px', fontWeight: '200' }}>
              {uiMode === 'MODE_LOGIN' ?
                <span>{t("I18N_User_Login")}</span>
                :
                <span>{t("I18N_Forgot_pwd")}</span>
              }
            </Modal.Title>
          </Modal.Header>

          <Modal.Body>
            { window.ENV === 'TEST' ?
              <div style={{paddingLeft:'18px', paddingRight:'15px'}}>
                      <div style={{padding:'10px', width:'100%', borderRadius:'7px', backgroundColor:'red', color:'white',
                                   textAlign:'center', fontSize:'16px', fontWeight: '800'}}>
                        <FiAlertTriangle size={22} style={{marginTop:'-3px', marginRight:'10px'}}/>
                        {t("I18N_This_is_test_env")}
                      </div>
              </div>
            :
              null
            }
            {uiMode === 'MODE_LOGIN' || uiMode === 'MODE_MFA_VERIFY' ?

              <Form onSubmit={handleLoginSubmit} className="m-3" style={{ fontSize: '13px', fontWeight: '300' }}>
                <fieldset disabled={loading}>
                  <Form.Group as={Row} className="mb-3 mt-3" controlId="formPlaintextUsername">
                    <Form.Label column size="sm">
                      {t("I18N_Username")}
                    </Form.Label>
                    <Col sm="9">
                      <Form.Control size="sm" type="text" name="username" value={username} onChange={(e) => onLoginInputChange(e)} placeholder="" style={{ fontWeight: '200' }} />
                    </Col>
                  </Form.Group>

                  <Form.Group as={Row} className="mb-4" controlId="formPlaintextPassword">
                    <Form.Label column sm="3">
                      {t("I18N_Password")}
                    </Form.Label>
                    <Col sm="9" style={{ position:'relative'}}>
                      <Form.Control size="sm" ref={inputRef} type={hidePwd ? "password" : "text"} name="password" value={password}
                                    onChange={(e) => onLoginInputChange(e)} placeholder="" style={{ fontWeight: '200' }} />

                      <span onClick={handleTogglePwd} style={{ marginLeft:'-60px', cursor:'pointer', color:'rgb(100,100,100)', position:'absolute', top:'0', right:'20px'}}>
                        { hidePwd ?
                          <BiHide size={18} style={{marginTop:'7px'}} />
                        :
                          <BiShow size={18} style={{marginTop:'7px'}} />
                        }
                      </span>
                    </Col>
                  </Form.Group>

                  {uiMode === 'MODE_MFA_VERIFY' ?
                    <Form.Group as={Row} className="mb-3 mt-3" controlId="formPlaintextUsername">
                      <Form.Label column size="sm">
                        {t("I18N_Veri_Code")}
                      </Form.Label>
                      <Col sm="9">
                        <Form.Control size="sm" type="text" name="veriCode" value={veriCode} onChange={(e) => onLoginInputChange(e)} style={{ fontWeight: '200' }} />
                      </Col>
                    </Form.Group>
                    :
                    null
                  }

                  {/* ### Not sure why the bottom margin setting of the Form does not work, so need to set here ### */}
                  <Form.Group as={Row} className="mb-2 mt-3">
                    <Form.Label column sm="10" style={{ color: 'rgba(200,0,0)' }}>
                      {errorMessage}
                    </Form.Label>
                    <Col sm="2">
                      <Button variant="outline-secondary" size="sm" type="submit" className="mb-3" style={{ float: 'right', fontWeight: '300' }}>
                        {resendCode ? t("I18N_Resend_code") : t("I18N_Login")}
                      </Button>
                    </Col>
                  </Form.Group>

                  { !configInfo.appConfig.isSimpleUserCreation ?
                  <Form.Group className="mt-2 mb-4">
                    <div display='flex' style={{ width: '100%', paddingBottom: '5px' }}>
                      <span style={{ cursor: 'pointer', float: 'right', fontWight: '200', color: 'SteelBlue' }} onClick={onSetForgotPwdMode}>{t("I18N_Forgot_your_pwd")}</span>
                    </div>
                  </Form.Group>
                  : null
                  }
                </fieldset>
                <LoadingSpinnerForModal loading={loading} />
              </Form>
              :
              <Form className="m-3" style={{ fontSize: '13px', fontWeight: '300' }}>
                {uiMode === 'MODE_FORGOT_PWD' ?
                  (<>
                    <fieldset disabled={loading}>
                      <Form.Group as={Row} className="mb-3 mt-3" controlId="formPlaintextUsername">
                        <Form.Label column size="sm">
                          {t("I18N_Username")}
                        </Form.Label>
                        <Col sm="9">
                          <Form.Control size="sm" type="text" name="username2" value={username2} onChange={(e) => onForgotPwdInputChange(e)} style={{ fontWeight: '200' }} />
                        </Col>
                      </Form.Group>

                      <Form.Group as={Row} className="mb-4" controlId="formPlaintextPassword">
                        <Form.Label column sm="3">
                          {t("I18N_Email")}
                        </Form.Label>
                        <Col sm="9">
                          <Form.Control size="sm" type="text" name="email" value={email} onChange={(e) => onForgotPwdInputChange(e)} style={{ fontWeight: '200' }} />
                        </Col>
                      </Form.Group>

                      {/* ### Not sure why the bottom margin setting of the Form does not work, so need to set here ### */}
                      <Form.Group as={Row} className="mb-2 mt-3">
                        <Form.Label column sm="7" style={{ color: 'rgba(200,0,0)' }}>
                          {forgotPwdErrorMessage}
                        </Form.Label>
                        <Col sm="3">
                          <Button onClick={handleForgotPwdSubmit} variant="outline-secondary" size="sm" type="submit" className="mb-3" style={{ float: 'right', fontWeight: '300' }}>
                            {t("I18N_Submit")}
                          </Button>
                        </Col>
                        <Col sm="2">
                          <Button onClick={handleForgotPwdCancel} variant="outline-secondary" size="sm" type="close" className="mb-3" style={{ float: 'right', fontWeight: '300' }}>
                            {t("I18N_Cancel")}
                          </Button>
                        </Col>
                      </Form.Group>
                    </fieldset>
                    <LoadingSpinnerForModal loading={loading} />
                  </>
                  )
                  :
                  <>
                    <Form.Group as={Row} className="mb-3 mt-3" controlId="formPlaintextUsername">
                      <Form.Label column size="sm">
                        {t("I18N_ERR_Forgot_pwd_done")}
                      </Form.Label>
                    </Form.Group>

                    {/* ### Not sure why the bottom margin setting of the Form does not work, so need to set here ### */}
                    <Form.Group as={Row} className="mb-2 mt-3">
                      <Form.Label column sm="10" style={{ color: 'rgba(200,0,0)' }}>
                        {forgotPwdErrorMessage}
                      </Form.Label>
                      <Col sm="2">
                        <Button onClick={handleForgotPwdClose} variant="outline-secondary" size="sm" type="close" className="mb-3" style={{ float: 'right', fontWeight: '300' }}>
                          {t("I18N_OK")}
                        </Button>
                      </Col>
                    </Form.Group>
                  </>
                }
              </Form>
            }
          </Modal.Body>

        </Modal>
      :
        <Modal show={true} centered>
          <ChangePwdPromptAlert />
        </Modal>
      }

    </React.Fragment>
  )
}

export default Login;
